export default __webpack_public_path__ + "static/media/googlelogo.39c52b1b.png";